import { useState } from 'react';
import OrganizationChart from 'components/IncidentConfig/OrganizationChart';
import RosterActions from 'components/IncidentConfig/roster/RosterActions';
import RosterTable from 'components/IncidentConfig/roster/RosterTable';
import type { RosterViewMode } from 'components/IncidentConfig/roster/types';

import { useCreateRosterDraft } from './CreateRosterDraftContext';

export function DraftRosterWorkspace() {
  const { members, removeMember } = useCreateRosterDraft();
  const [viewMode, setViewMode] = useState<RosterViewMode>('orgchart');

  return (
    <div className="tw:flex tw:h-full tw:min-h-0 tw:flex-1 tw:flex-col">
      <RosterActions viewMode={viewMode} onViewModeChange={setViewMode} />

      {viewMode === 'table' ? (
        <div className="tw:min-h-0 tw:flex-1 tw:overflow-auto">
          <RosterTable
            rosterData={members}
            isRosterLoading={false}
            editMemberButtonClicked={() => undefined}
            removeMemberButtonClicked={(member) => removeMember(member.userId)}
            removeSelfFromIncidentButtonClicked={(member) =>
              removeMember(member.userId)
            }
            onDeleteSchedule={() => undefined}
            onToggleButtonClick={() => undefined}
            simplified
            showApprovalAuthority={false}
          />
        </div>
      ) : (
        <div className="tw:min-h-0 tw:flex-1">
          <OrganizationChart incidentMembers={members} />
        </div>
      )}
    </div>
  );
}

export default DraftRosterWorkspace;
